import { useState } from 'react';
import type {ChiPhiDiemDanhMuon} from "@/services/ChiPhiDiemDanhMuon";

export enum ELoaiDiemDanh {
  DIEM_DANH_DAU_GIO = "Điểm danh đầu giờ",
  DIEM_DANH_LAI = "Điểm danh lại",
  DIEM_DANH_CUOI_GIO = "Điểm danh cuối giờ",
  DIEM_DANH_MUON = "Điểm danh muộn",
  DUA_CON_DEN_TRUONG = "Đưa con đến trường",
  DA_DON_CON = "Đã đón con",
}

export enum EKieuTinhTienDiemDanh {
  THOI_LUONG = "Thời lượng",
  TUNG_KHOANG_THOI_GIAN = "Từng khoảng thời gian",
}

export enum EDonViTinhThoiGian {
  GIO = "Giờ",
  PHUT = "Phút",
}

export enum EKieuNhaTruongKhoan {
  CACH_1 = "THEO_CHAM_CONG",
  CACH_2 = "DIEM_DANH_CHAU"
}

export enum ELePhiTrongMuon {
  CACH_1 = "PHU_HUYNH_NOP",
  CACH_2 = "NHA_TRUONG_KHOAN"
}


export default () => {
  const [danhSach, setDanhSach] = useState<ChiPhiDiemDanhMuon.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});

  return {
    danhSach,
    loading,
    setLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    setDanhSach,
  };
};
